'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.graphqlService = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.handleResponse = handleResponse;
exports.handleData = handleData;
exports.hasErrors = hasErrors;
exports.handlerError = handlerError;

var _Cardshopql = require('acq-components/lib/services/api/cardshopql/Cardshopql');

var _actions = require('../redux/actions');

var actions = _interopRequireWildcard(_actions);

var _queries = require('../queries');

var _translations = require('../translations');

var _acqSystemApi = require('acq-system-api');

var _utils = require('acq-utils/lib/utils');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RESPONSE_DATA_KEY = 'cardShop';
var ssrNext = function ssrNext(data) {
  return data;
};
var productTypeToPage = {
  viewAllCards: 'vac',
  compare: 'compare'
};
var graphqlService = exports.graphqlService = function graphqlService(_ref) {
  var store = _ref.store,
      _ref$next = _ref.next,
      next = _ref$next === undefined ? ssrNext : _ref$next,
      action = _ref.action;

  if (action.type !== actions.FETCH_DATA) {
    return next(action);
  }
  next({ type: actions.FETCH_DATA_IN_PROGRESS });

  var params = action.payload;
  var shop = params.shop;

  var queryCountryCodeFormat = params.countryCode.toLowerCase().replace('-', '_');
  // This supports both legacy urls and one seo urls
  var countryCode = queryCountryCodeFormat.split('_').pop();

  var cardName = (0, _translations.translateCardShortName)(countryCode, shop, params.cardName);
  var clientHost = (0, _utils.isBrowser)() ? window.location.hostname : 'localhost';
  var apiHost = (0, _acqSystemApi.getApiHost)(clientHost);
  var queriesByCountryCode = _queries.queries[params.productType];
  var queriesByShop = queriesByCountryCode[countryCode] || queriesByCountryCode.defaultCountry;

  var options = {
    query: queriesByShop[shop],
    variables: {
      country: queryCountryCodeFormat, //es_mx, en_au, fr_fr, ja_jp
      shop: shop, // business or corporate
      page: cardName || productTypeToPage[params.productType] || 'vac',
      eep: params.ieep
    }
  };

  return (0, _Cardshopql.cardshopql)(apiHost, options).then(handleResponse(next, params)).then(handleData(next, params, options.variables.page)).catch(handlerError(next));
};

function handleResponse(dispatch, params) {
  return function (response) {
    dispatch({
      type: actions.FETCH_DATA_COMPLETE,
      payload: (0, _extends3.default)({}, response, {
        params: params
      })
    });

    return response.data;
  };
}

function handleData(dispatch, params, pageName) {
  return function (_ref2) {
    var errors = _ref2.errors,
        data = _ref2.data;

    if (hasErrors(dispatch, errors, data)) return;

    var payload = (0, _extends3.default)({}, data[RESPONSE_DATA_KEY], {
      params: params,
      pageName: pageName
    });

    return dispatch({
      type: actions.PAGE_DATA_RECEIVED,
      payload: payload
    });
  };
}

function hasErrors(dispatch, errors, data) {
  var hasErrors = !!errors;
  var dataFound = data && data[RESPONSE_DATA_KEY];
  var cardDataFound = !!(dataFound && dataFound.cards && dataFound.cards.length);

  if (hasErrors) {
    return dispatch({
      type: actions.PAGE_DATA_ERROR,
      payload: errors
    });
  }

  if (!dataFound || !cardDataFound) {
    return dispatch({
      type: actions.PAGE_DATA_NOT_FOUND,
      payload: { errors: errors, data: data }
    });
  }

  // If we made it to this line, none of the errors we're checking for are present
  return;
}

function handlerError(dispatch) {
  return function (error) {
    return dispatch({
      type: actions.FETCH_DATA_FAILED,
      payload: error
    });
  };
}